const accidentKeys = {
  all: ['SAFETY_ACCIDENT'],
  accidentList: () => [...accidentKeys.all, 'ACCIDENT_LIST'],
  accident: ({ seq }) => [...accidentKeys.all, 'ACCIDENT', seq],
  nameList: () => [...accidentKeys.all, 'NAME_LIST'],
};

export default accidentKeys;
